import {
  SET_CURRENT_ACCOUNT_ID,
  SET_CURRENT_ACCOUNT,
  SET_CURRENT_ACCOUNT_SETTINGS,
  SET_CURRENT_ACCOUNT_USER,
  SET_CURRENT_ACCOUNT_PERMISSIONS,
  SET_CURRENT_ACCOUNT_ITEM_PERMISSIONS,
  SET_CURRENT_ACCOUNT_FEATURE_FLAGS,
  SET_CURRENT_ACCOUNT_IS_PAUSED,
  SET_TIMEZONES_LIST,
  SET_RECENTLY_USED_TAGS,
  SET_COMPLETED_CAMPAIGNS_RECORDS_WITHOUT_STATS,
  SET_TARGETS_WITH_NO_STATS,
  SET_PING_TREE_TARGETS_WITH_NO_STATS,
  SET_AFFILIATES,
  SET_BUYERS,
  SET_CURRENT_ACCOUNT_USER_GROUPS,
  SET_CALL_PLANS,
  RESET
} from './mutationTypes';

import { setActionStatusPending, setActionStatusSuccess, setActionStatusError } from './helpers';

export default {
  setActionStatusPending,
  setActionStatusSuccess,
  setActionStatusError,
  [SET_CURRENT_ACCOUNT_ID](state, accountId) {
    state.currentAccountId = accountId;
  },

  [SET_CURRENT_ACCOUNT](state, account) {
    state.currentAccount = account;
  },

  [SET_CURRENT_ACCOUNT_SETTINGS](state, accountSettings) {
    state.currentAccountSettings = accountSettings;
  },

  [SET_CURRENT_ACCOUNT_USER](state, accountUser) {
    state.currentAccountUser = accountUser;
  },

  [SET_CURRENT_ACCOUNT_PERMISSIONS](state, permissions) {
    state.currentAccountPermissions = permissions;
  },

  [SET_CURRENT_ACCOUNT_ITEM_PERMISSIONS](state, permissions) {
    state.currentAccountItemPermissions = permissions;
  },

  [SET_CURRENT_ACCOUNT_FEATURE_FLAGS](state, featureFlags) {
    state.currentAccountFeatureFlags = featureFlags;
  },

  [SET_TIMEZONES_LIST](state, timezones) {
    state.timezones = timezones;
  },

  [SET_RECENTLY_USED_TAGS](state, { formName, recentlyUsedTags }) {
    state.recentlyUsedTags = {
      ...state.recentlyUsedTags,
      [formName]: recentlyUsedTags
    };
  },

  [SET_COMPLETED_CAMPAIGNS_RECORDS_WITHOUT_STATS](state, campaigns) {
    state.completedCampaignsWithoutStats = campaigns;
  },

  [SET_TARGETS_WITH_NO_STATS](state, targets) {
    state.targetsWithoutStats = targets;
  },

  [SET_PING_TREE_TARGETS_WITH_NO_STATS](state, pingTreeTargets) {
    state.pingTreeTargetsWithoutStats = pingTreeTargets;
  },

  [SET_AFFILIATES](state, affiliates) {
    state.affiliates = affiliates;
  },

  [SET_BUYERS](state, buyers) {
    state.buyers = buyers;
  },

  [SET_CURRENT_ACCOUNT_USER_GROUPS](state, groups) {
    state.currentAccountUserGroups = groups;
  },
  
  [SET_CALL_PLANS](state, callPlans) {
    state.callPlans = callPlans;
  },

  [SET_CURRENT_ACCOUNT_IS_PAUSED](state, isPaused) {
    state.currentAccountIsPaused = isPaused;
  },

  [RESET]() {}
};